/**
 * Parse a semver-like version string (e.g. "1.2.0", "2.0") into [major, minor, patch].
 * Missing parts are treated as 0.
 */
export function parseVersion(version: string): [number, number, number] {
  const parts = version.replace(/^v/i, '').split('.');
  return [
    parseInt(parts[0] ?? '0', 10) || 0,
    parseInt(parts[1] ?? '0', 10) || 0,
    parseInt(parts[2] ?? '0', 10) || 0,
  ];
}

/**
 * Returns true if current is less than required (i.e. upgrade is required).
 */
export function isVersionLessThan(current: string, required: string): boolean {
  const [cMajor, cMinor, cPatch] = parseVersion(current);
  const [rMajor, rMinor, rPatch] = parseVersion(required);
  if (cMajor !== rMajor) return cMajor < rMajor;
  if (cMinor !== rMinor) return cMinor < rMinor;
  return cPatch < rPatch;
}
